import { sanitizeContentHtml } from "@/lib/content/sanitize";
import { restoreLegacyParagraphs } from "@/lib/content/legacy-html";
import { publicUrl } from "@/lib/content/path";

function escapeHtml(value: string) {
  return value
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;");
}

function youtubeEmbed(value: string) {
  try {
    const url = new URL(value);
    const hostname = url.hostname.replace(/^www\./i, "").toLowerCase();
    let videoId = "";
    let isShort = false;

    if (hostname === "youtu.be") {
      videoId = url.pathname.split("/").filter(Boolean)[0] || "";
    } else if (hostname === "youtube.com" || hostname === "m.youtube.com") {
      const parts = url.pathname.split("/").filter(Boolean);
      if (parts[0] === "watch") videoId = url.searchParams.get("v") || "";
      if (parts[0] === "shorts") {
        videoId = parts[1] || "";
        isShort = true;
      }
      if (parts[0] === "embed") videoId = parts[1] || "";
    }

    if (!/^[a-zA-Z0-9_-]{6,}$/.test(videoId)) return null;
    return { url: `https://www.youtube.com/embed/${videoId}`, isShort };
  } catch {
    return null;
  }
}

function youtubePreview(url: string) {
  const embed = youtubeEmbed(url);
  if (!embed) return null;
  return `<figure data-block="embed" class="youtube-embed${embed.isShort ? " youtube-embed-short" : ""}"><iframe src="${escapeHtml(embed.url)}" title="Dermalife YouTube video" loading="lazy" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe></figure>`;
}

function transformYouTubeLinks(html: string) {
  let next = html.replace(/<p([^>]*)>\s*(?:<a\s+[^>]*href=(["'])(.*?)\2[^>]*>\s*(?:https?:\/\/)?(?:www\.)?(?:youtube\.com|youtu\.be)[^<]*<\/a>|(https?:\/\/(?:www\.)?(?:youtube\.com|youtu\.be)\/[^\s<]+))\s*<\/p>/gi, (match, attrs: string, _quote: string, href: string | undefined, bareUrl: string | undefined) => {
    const preview = youtubePreview(href || bareUrl || "");
    return preview || match;
  });

  next = next.replace(/<p([^>]*)\sdata-block=(["'])embed\2([^>]*)>\s*<a\s+[^>]*href=(["'])(.*?)\4[^>]*>[\s\S]*?<\/a>\s*<\/p>/gi, (match, _before: string, _dataQuote: string, _after: string, _hrefQuote: string, href: string) => {
    const preview = youtubePreview(href);
    return preview || match;
  });

  return next;
}

function rewritePublicLinks(html: string) {
  return html.replace(/\b(href|src)=(["'])(.*?)\2/gi, (match, attribute: string, quote: string, value: string) => {
    return `${attribute}=${quote}${publicUrl(value)}${quote}`;
  });
}

export function renderSafeContentHtml(html: string | null | undefined) {
  return rewritePublicLinks(transformYouTubeLinks(restoreLegacyParagraphs(sanitizeContentHtml(html))));
}

export function SafeHtml({ html, className = "" }: { html?: string | null; className?: string }) {
  if (!html) return null;
  return <div className={className} dangerouslySetInnerHTML={{ __html: renderSafeContentHtml(html) }} />;
}
